import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDataWAuth, postDataWAuth } from "../../../utils/api-service";
import { EXTENSION_URI, LOG_SEARCH_FILTER, APP_VIEW } from "../../../constants/constant";

export const fetchLogs = createAsyncThunk(
  "logsExtension/fetchLogs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDataWAuth(EXTENSION_URI, { view: APP_VIEW.LOGS });
      return response.data?.extensionRequestList || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch logs");
    }
  }
);

export const searchLogs = createAsyncThunk(
  "logsExtension/searchLogs",
  async (filterData, { rejectWithValue }) => {
    try {
      const response = await postDataWAuth(LOG_SEARCH_FILTER, filterData, { view: APP_VIEW.LOGS });
      return response.data?.extensionRequestList || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to search logs");
    }
  }
);

const initialState = {
  logs: [],
  loading: false,
  error: null,
  filters: {},
};

const logsExtensionSlice = createSlice({
  name: "logsExtension",
  initialState,
  reducers: {
    setLogsFilters: (state, action) => {
      state.filters = action.payload;
    },
    clearLogsFilters: (state) => {
      state.filters = {};
    },
    clearLogsError: (state) => {
      state.error = null;
    },
    resetLogs: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload;
      })
      .addCase(fetchLogs.rejected, (state, action) => {
        state.loading = false;
        state.logsError = action.payload;
      });

    builder
      .addCase(searchLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload;
      })
      .addCase(searchLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setLogsFilters,
  clearLogsFilters,
  clearLogsError,
  resetLogs,
} = logsExtensionSlice.actions;

export default logsExtensionSlice.reducer;
